@use "@styles/tokens";

// Visual source of truth: docs/specs/2026-09-30-institution-icon.md.
// Sizes and glyph boxes are Figma geometry with no token family, so they
// live in component-scoped custom properties.

@layer base-components {
    .institutionIcon {
        // Override hatch (spec "Public API"): set these via className.
        --institution-icon-size: 20px;
        --institution-icon-bg: var(--bg-neutral);

        // AvatarGroup clips its stack ring along this radius.
        --avatar-radius: var(--radius-full);

        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: var(--institution-icon-size);
        height: var(--institution-icon-size);
        overflow: hidden;
        border-radius: var(--radius-full);
        color: var(--fg-secondary);
        background-color: var(--institution-icon-bg);
        user-select: none;

        &[data-source="catalogue"] {
            --institution-icon-bg: var(--institution-icon-brand-bg);

            color: var(--institution-icon-brand-fg, var(--fg-secondary));
        }

        &[data-size="xs"] {
            --institution-icon-size: 16px;
        }

        &[data-size="sm"] {
            --institution-icon-size: 20px;
        }

        &[data-size="md"] {
            --institution-icon-size: 24px;
        }

        &[data-size="lg"] {
            --institution-icon-size: 32px;
        }

        &[data-size="xl"] {
            --institution-icon-size: 40px;
        }
    }

    .glyph {
        position: absolute;
        top: var(--institution-icon-glyph-top);
        left: var(--institution-icon-glyph-left);
        width: var(--institution-icon-glyph-width);
        height: var(--institution-icon-glyph-height);
    }

    .image {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .fallback {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;

        // Icons carry their default ink in a root `color` attribute.
        > svg {
            width: 50%;
            height: 50%;
            color: inherit;
        }
    }
}
